import { Component, OnInit } from '@angular/core';
import { MapService } from '../../../../services/map.service';
import { PopupService } from '../../../../services/popup.service';
import { MyStuffService } from '../../../../services/my-stuff.service';
import { Observable } from 'rxjs/Rx';

@Component({
  selector: 'app-maps-section',
  templateUrl: './maps-section.component.html',
  styleUrls: ['./maps-section.component.less']
})
export class MapsSectionComponent implements OnInit {

  constructor(public myStuffService: MyStuffService, public popupService: PopupService,
    public mapService: MapService) { }
  mapsInputElement: any;

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.mapsInputElement = document.getElementById('maps-search-input');
    if(this.mapsInputElement) {
    Observable.fromEvent(this.mapsInputElement, 'input')
      .debounceTime(500)
      .subscribe((event) => {
        this.myStuffService.fetchMapsSection();
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/popups/my-stuff/maps-section/maps-section.component.ts